import React, { useState } from 'react';

const HomePage = ({ user, onSelectStation, userRole, hasPageAccess, isAdmin = false, isGuestMode = false }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const allRooms = [
    // Category 1: CSSD Operations
    {
      id: 'washing',
      title: 'ห้องล้างเครื่องมือ',
      subtitle: 'Decontamination',
      description: 'ล้างทำความสะอาดและทำลายเชื้อเครื่องมือแพทย์และทันตกรรมที่ใช้แล้ว',
      icon: '🧽',
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      shadowColor: 'rgba(245, 87, 108, 0.4)',
      category: 'cssd'
    },
    {
      id: 'packaging',
      title: 'ห้องแพ็กซอง',
      subtitle: 'Packaging & Labeling',
      description: 'บรรจุเครื่องมือลงซอง ตรวจเช็คความสะอาด และพิมพ์บาร์โค้ด',
      icon: '🏷️',
      gradient: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
      shadowColor: 'rgba(254, 207, 239, 0.4)',
      category: 'cssd'
    },
    {
      id: 'supply',
      title: 'ห้อง Sterile',
      subtitle: 'Sterilization Zone',
      description: 'นำเครื่องมือเข้าตู้อบฆ่าเชื้อ และบันทึกข้อมูลการอบ',
      icon: '🏥',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      shadowColor: 'rgba(102, 126, 234, 0.4)',
      category: 'cssd'
    },
    {
      id: 'dispense',
      title: 'ห้องจ่ายเครื่องมือ',
      subtitle: 'Dispensing & Orders',
      description: 'จ่ายเครื่องมือปราศจากเชื้อตามใบสั่งของของแต่ละคลินิก',
      icon: '📤',
      gradient: 'linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%)',
      shadowColor: 'rgba(102, 166, 255, 0.4)',
      category: 'cssd'
    },
    {
      id: 'recall',
      title: 'เรียกคืนวัสดุ (Recall)',
      subtitle: 'Material Recall',
      description: 'อายัดและเรียกคืนเครื่องมือและวัสดุที่มีปัญหาจากห้องอบหรือรอบที่มีปัญหา',
      icon: '⚠️',
      gradient: 'linear-gradient(135deg, #f5af19 0%, #f12711 100%)',
      shadowColor: 'rgba(245, 175, 25, 0.4)',
      category: 'cssd'
    },

    // Category 2: Inventory Management
    {
      id: 'consumable-dashboard',
      title: 'แดชบอร์ดสิ้นเปลือง 4 คลัง',
      subtitle: 'Consumable 4-Warehouse Dashboard',
      description: 'ตรวจสอบภาพรวมสต็อกวัสดุสิ้นเปลืองและการกระจายตัวใน 4 คลังหลักแบบเรียลไทม์',
      icon: '📊',
      gradient: 'linear-gradient(135deg, #3b82f6 0%, #2dd4bf 100%)',
      shadowColor: 'rgba(59, 130, 246, 0.4)',
      category: 'inventory'
    },
    {
      id: 'consumable',
      title: 'วัสดุสิ้นเปลือง',
      subtitle: 'Consumable Stock',
      description: 'จัดการสต็อกวัสดุประเภทใช้แล้วทิ้ง ตรวจสอบวันหมดอายุ',
      icon: '📦',
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      shadowColor: 'rgba(79, 172, 254, 0.4)',
      category: 'inventory'
    },
    {
      id: 'durable',
      title: 'วัสดุคงทน',
      subtitle: 'Durable Asset Stock',
      description: 'ตรวจสอบ จัดเก็บ และนับจำนวนวัสดุคงทนในคลัง',
      icon: '🏢',
      gradient: 'linear-gradient(135deg, #2af598 0%, #009efd 100%)',
      shadowColor: 'rgba(42, 245, 152, 0.4)',
      category: 'inventory'
    },
    {
      id: 'handpiece',
      title: 'หัวกรอทันตกรรม',
      subtitle: 'Dental Handpieces',
      description: 'จัดการ ค้นหา และติดตามประวัติการใช้งานหัวกรอ',
      icon: '🦷',
      gradient: 'linear-gradient(135deg, #f12711 0%, #f5af19 100%)',
      shadowColor: 'rgba(245, 175, 25, 0.4)',
      category: 'inventory'
    },
    {
      id: 'receipt-stockin',
      title: 'รับเข้าสินค้าตามใบเสร็จ',
      subtitle: 'Receipt Stock-In',
      description: 'บันทึกรับเข้าวัสดุการแพทย์ แนบรูปใบเสร็จ บันทึก Lot/EXP และอัปเดตสต็อก',
      icon: '📥',
      gradient: 'linear-gradient(135deg, #0ba360 0%, #3cba92 100%)',
      shadowColor: 'rgba(11, 163, 96, 0.4)',
      category: 'inventory'
    },
    {
      id: 'dispense-report',
      title: 'รายงานการเบิกจ่ายประจำเดือน',
      subtitle: 'Monthly Dispense Report',
      description: 'สรุปยอดและมูลค่าการเบิกจ่ายวัสดุรายเดือน แยกตามห้องตรวจและสาขาทันตกรรม',
      icon: '📄',
      gradient: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
      shadowColor: 'rgba(5, 150, 105, 0.4)',
      category: 'inventory'
    },

    // Category 3: General Systems
    {
      id: 'clinic-order',
      title: 'สั่งเครื่องมือและวัสดุ',
      subtitle: 'Clinic Requisition',
      description: 'สั่งเบิกเครื่องมือหรือวัสดุสิ้นเปลือง/คงทนสำหรับคลินิก',
      icon: '🛒',
      gradient: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)',
      shadowColor: 'rgba(253, 160, 133, 0.4)',
      category: 'general'
    },
    {
      id: 'barcode-tracking',
      title: 'ระบบค้นหาบาร์โค้ด',
      subtitle: 'Barcode Search',
      description: 'ค้นหา ตรวจสอบสถานะ และดูตำแหน่งของเครื่องมือตามบาร์โค้ด',
      icon: '🔍',
      gradient: 'linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)',
      shadowColor: 'rgba(161, 196, 253, 0.4)',
      category: 'general'
    },
    {
      id: 'trace',
      title: 'ประวัติ QR Code',
      subtitle: 'QR Code History',
      description: 'สแกน QR Code เพื่อตรวจสอบบันทึกเส้นทางการฆ่าเชื้อย้อนหลัง',
      icon: '📍',
      gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
      shadowColor: 'rgba(56, 239, 125, 0.4)',
      category: 'general'
    },
    {
      id: 'durable-dashboard',
      title: 'แดชบอร์ดวงจรวัสดุคงทน',
      subtitle: 'Durable Lifecycle',
      description: 'ตรวจสอบรายงาน สรุปจำนวน และตำแหน่งของวัสดุคงทนตามวัฏจักรงาน CSSD',
      icon: '📊',
      gradient: 'linear-gradient(135deg, #37ecba 0%, #72afd3 100%)',
      shadowColor: 'rgba(114, 175, 211, 0.4)',
      category: 'general'
    },
    {
      id: 'sterile-locations',
      title: 'ตำแหน่งสิ่งของในห้อง sterile',
      subtitle: 'Sterile Storage Layout',
      description: 'ตรวจสอบแผนผังชั้นวางของ ค้นหารายการวัสดุคงทนตามตำแหน่ง ตู้ ชั้น แถว',
      icon: '📍',
      gradient: 'linear-gradient(135deg, #1abc9c 0%, #16a085 100%)',
      shadowColor: 'rgba(26, 188, 156, 0.4)',
      category: 'general'
    },
    {
      id: 'storage-admin',
      title: 'จัดการคลังรูป & ซิงค์ R2',
      subtitle: 'Storage & R2 Migration',
      description: 'ตรวจสอบคลังจัดเก็บรูปใบเสร็จ สลับรูปภาพ และโอนย้ายไปยัง Cloudflare R2 อัตโนมัติ',
      icon: '🗄️',
      gradient: 'linear-gradient(135deg, #0ea5e9 0%, #2563eb 100%)',
      shadowColor: 'rgba(14, 165, 233, 0.4)',
      category: 'general'
    },
    {
      id: 'dental-risk',
      title: 'รายงานความเสี่ยงทันตกรรม',
      subtitle: isAdmin ? 'Dental Incident & Risk' : 'Dental Incident & Risk (risk.fangdent.com)',
      description: isAdmin
        ? 'ระบบบันทึกอุบัติการณ์ ประเมินระดับความรุนแรง (Level A-I) สอบสวน RCA และมาตรการป้องกัน'
        : 'ระบบบันทึกอุบัติการณ์สำหรับทันตกรรม (คลิกเพื่อเปิดเว็บ risk.fangdent.com)',
      icon: '🛡️',
      gradient: 'linear-gradient(135deg, #ef4444 0%, #b91c1c 100%)',
      shadowColor: 'rgba(239, 68, 68, 0.4)',
      category: 'general',
      badge: !isAdmin ? '🔗 risk.fangdent.com' : undefined
    },

    // Category 4: Admin Settings
    {
      id: 'manage-users',
      title: 'จัดการผู้ใช้งาน',
      subtitle: 'User Management',
      description: 'จัดการบัญชีผู้ใช้งาน กำหนดบทบาท และสิทธิ์การเข้าถึงหน้า',
      icon: '👤',
      gradient: 'linear-gradient(135deg, #fc6076 0%, #ff9a44 100%)',
      shadowColor: 'rgba(252, 96, 118, 0.4)',
      category: 'admin'
    },
    {
      id: 'register',
      title: 'ลงทะเบียนวัสดุใหม่',
      subtitle: 'Register Materials',
      description: 'ลงทะเบียนรหัสวัสดุ บันทึกข้อมูลตั้งต้นก่อนผูกบาร์โค้ด',
      icon: '📝',
      gradient: 'linear-gradient(135deg, #13f1fc 0%, #0470dc 100%)',
      shadowColor: 'rgba(4, 112, 220, 0.4)',
      category: 'admin'
    },
    {
      id: 'set-config',
      title: 'ตั้งค่าชุดเครื่องมือ',
      subtitle: 'Set Configurator',
      description: 'กำหนดส่วนประกอบสำหรับชุดเครื่องมือทันตกรรมแบบเป็นเซ็ต',
      icon: '⚙️',
      gradient: 'linear-gradient(135deg, #65799b 0%, #5e2563 100%)',
      shadowColor: 'rgba(94, 37, 99, 0.4)',
      category: 'admin'
    },
    {
      id: 'doctor-box',
      title: 'กล่องจัดชุดทันตแพทย์',
      subtitle: 'Doctor Box Setup',
      description: 'จัดการจัดเตรียมชุดเครื่องมือเฉพาะสำหรับทันตแพทย์แต่ละคน',
      icon: '🧰',
      gradient: 'linear-gradient(135deg, #37ecba 0%, #72afd3 100%)',
      shadowColor: 'rgba(114, 175, 211, 0.4)',
      category: 'admin'
    }
  ];

  const categories = [
    { id: 'cssd', name: '🔧 งานห้องปฏิบัติการ CSSD' },
    { id: 'inventory', name: '📦 การจัดการคลังสต็อก' },
    { id: 'general', name: '🖥️ ระบบทั่วไป' },
    { id: 'admin', name: '👑 การดูแลระบบ (Admin Only)' }
  ];

  // กรองห้องตามสิทธิ์การเข้าใช้งาน
  const allowedRooms = allRooms.filter(room => {
    if (room.id === 'dental-risk') {
      return !isGuestMode;
    }
    if (room.category === 'admin') {
      return userRole === 'admin' || isAdmin;
    }
    return hasPageAccess ? hasPageAccess(room.id) : true;
  });

  const handleStationClick = (roomId) => {
    if (roomId === 'dental-risk') {
      if (isAdmin) {
        onSelectStation('dental-risk');
      } else {
        window.location.href = 'https://risk.fangdent.com';
      }
      return;
    }
    onSelectStation(roomId);
  };

  // กรองห้องตามช่องค้นหา
  const filteredRooms = allowedRooms.filter(room => {
    const query = searchQuery.toLowerCase().trim();
    if (!query) return true;
    return (
      room.title.toLowerCase().includes(query) ||
      room.subtitle.toLowerCase().includes(query) ||
      room.description.toLowerCase().includes(query) ||
      room.id.toLowerCase().includes(query)
    );
  });

  // กรองเอาเฉพาะหมวดหมู่ที่มีห้องที่เข้าใช้งานได้จริง
  const renderedCategories = categories.map(cat => {
    const rooms = filteredRooms.filter(room => room.category === cat.id);
    return { ...cat, rooms };
  }).filter(cat => cat.rooms.length > 0);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '40px 20px',
      fontFamily: "'Segoe UI', 'Noto Sans Thai', -apple-system, BlinkMacSystemFont, sans-serif",
    }}>

      {/* Header Section */}
      <div style={{
        textAlign: 'center',
        marginBottom: '40px',
        animation: 'fadeInDown 0.8s ease-out',
      }}>
        <div style={{
          fontSize: '4em',
          marginBottom: '15px',
          filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))',
        }}>🏥</div>
        <h1 style={{
          color: '#ffffff',
          fontSize: 'clamp(1.8em, 4vw, 2.5em)',
          fontWeight: '700',
          margin: '0 0 10px 0',
          letterSpacing: '1px',
          textShadow: '0 2px 10px rgba(0,0,0,0.3)',
        }}>
          ระบบ CSSD
        </h1>
        <p style={{
          color: 'rgba(255,255,255,0.6)',
          fontSize: '1.1em',
          margin: '0 0 8px 0',
          fontWeight: '300',
        }}>
          Central Sterile Supply Department
        </p>
        <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          background: 'rgba(255,255,255,0.1)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          padding: '8px 20px',
          borderRadius: '30px',
          border: '1px solid rgba(255,255,255,0.15)',
          color: 'rgba(255,255,255,0.7)',
          fontSize: '0.9em',
        }}>
          <span>👤</span>
          <span>{user?.email}</span>
        </div>
      </div>

      {/* Station Selection Title */}
      <div style={{
        textAlign: 'center',
        marginBottom: '30px',
      }}>
        <h2 style={{
          color: 'rgba(255,255,255,0.9)',
          fontSize: 'clamp(1.2em, 3vw, 1.5em)',
          fontWeight: '500',
          margin: '0',
          letterSpacing: '0.5px',
        }}>
          เลือกห้องเพื่อปฏิบัติงานตามสิทธิ์ของคุณ
        </h2>
        <div style={{
          width: '60px',
          height: '3px',
          background: 'linear-gradient(90deg, #667eea, #f5576c, #4facfe)',
          borderRadius: '2px',
          margin: '12px auto 0',
        }} />
      </div>

      {/* Search Bar */}
      <div style={{
        width: '100%',
        maxWidth: '500px',
        marginBottom: '40px',
        position: 'relative',
        animation: 'fadeInDown 0.8s ease-out 0.1s both',
      }}>
        <input
          type="text"
          placeholder="🔍 ค้นหาห้องหรือสิทธิ์เข้าใช้งาน..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            width: '100%',
            padding: '14px 20px 14px 50px',
            borderRadius: '30px',
            border: '1px solid rgba(255, 255, 255, 0.15)',
            background: 'rgba(255, 255, 255, 0.08)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            color: '#ffffff',
            fontSize: '1em',
            outline: 'none',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
          }}
          onFocus={(e) => {
            e.target.style.background = 'rgba(255, 255, 255, 0.12)';
            e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
            e.target.style.boxShadow = '0 8px 25px rgba(255, 255, 255, 0.1)';
          }}
          onBlur={(e) => {
            e.target.style.background = 'rgba(255, 255, 255, 0.08)';
            e.target.style.borderColor = 'rgba(255, 255, 255, 0.15)';
            e.target.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
          }}
        />
        <span style={{
          position: 'absolute',
          left: '20px',
          top: '50%',
          transform: 'translateY(-50%)',
          fontSize: '1.2em',
          pointerEvents: 'none',
          opacity: 0.6
        }}>🔍</span>
        
        {searchQuery && (
          <button
            onClick={() => setSearchQuery('')}
            style={{
              position: 'absolute',
              right: '20px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'none',
              border: 'none',
              color: 'rgba(255, 255, 255, 0.6)',
              cursor: 'pointer',
              fontSize: '1.1em',
              outline: 'none',
              padding: '5px',
            }}
          >
            ✕
          </button>
        )}
      </div>

      {/* Categories container */}
      <div style={{
        width: '100%',
        maxWidth: '1200px',
        display: 'flex',
        flexDirection: 'column',
        gap: '40px',
        animation: 'fadeInUp 0.8s ease-out 0.2s both',
      }}>
        {renderedCategories.map((category, catIdx) => (
          <div key={category.id} style={{ width: '100%' }}>
            {/* Category Header */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '15px',
              marginBottom: '20px',
              paddingLeft: '10px',
            }}>
              <h3 style={{
                color: 'rgba(255, 255, 255, 0.95)',
                fontSize: '1.25em',
                fontWeight: '600',
                margin: 0,
                letterSpacing: '0.5px',
              }}>
                {category.name}
              </h3>
              <div style={{
                flex: 1,
                height: '1px',
                background: 'linear-gradient(90deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0) 100%)',
              }} />
            </div>

            {/* Grid of rooms in this category */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '20px',
              width: '100%',
            }}>
              {category.rooms.map((room, roomIdx) => (
                <StationCard
                  key={room.id}
                  station={room}
                  index={catIdx * 10 + roomIdx} // สำหรับการดีเลย์แอนิเมชัน
                  onClick={() => handleStationClick(room.id)}
                />
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* No Results Message */}
      {renderedCategories.length === 0 && (
        <div style={{
          textAlign: 'center',
          color: 'rgba(255,255,255,0.5)',
          marginTop: '40px',
          animation: 'fadeInUp 0.5s ease-out'
        }}>
          <div style={{ fontSize: '3em', marginBottom: '10px' }}>🔍</div>
          <p style={{ fontSize: '1.1em', margin: 0 }}>ไม่พบห้องปฏิบัติงานที่ตรงกับการค้นหา: "{searchQuery}"</p>
        </div>
      )}

      {/* CSS Keyframes */}
      <style>{`
        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes shimmer {
          0% { background-position: -200% center; }
          100% { background-position: 200% center; }
        }
        @keyframes pulse-glow {
          0%, 100% { box-shadow: 0 0 20px rgba(255,255,255,0.05); }
          50% { box-shadow: 0 0 40px rgba(255,255,255,0.1); }
        }
      `}</style>
    </div>
  );
};

const StationCard = ({ station, index, onClick }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <button
      id={`station-${station.id}`}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocus={() => setIsHovered(true)}
      onBlur={() => setIsHovered(false)}
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '30px 25px 25px',
        borderRadius: '20px',
        border: '1px solid rgba(255,255,255,0.12)',
        background: isHovered
          ? 'rgba(255,255,255,0.12)'
          : 'rgba(255,255,255,0.06)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        cursor: 'pointer',
        transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        transform: isHovered ? 'translateY(-8px) scale(1.02)' : 'translateY(0) scale(1)',
        boxShadow: isHovered
          ? `0 20px 60px ${station.shadowColor}, 0 0 0 1px rgba(255,255,255,0.2)`
          : '0 8px 32px rgba(0,0,0,0.2)',
        overflow: 'hidden',
        textAlign: 'center',
        outline: 'none',
        color: 'inherit',
        fontFamily: 'inherit',
        width: '100%',
        animation: `fadeInUp 0.6s ease-out ${0.05 * index + 0.3}s both`,
      }}
    >
      {/* Gradient Top Bar */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        background: station.gradient,
        transition: 'height 0.3s ease',
        ...(isHovered ? { height: '6px' } : {}),
      }} />

      {/* Badge (e.g. external link) */}
      {station.badge && (
        <div style={{
          position: 'absolute',
          top: '12px',
          right: '12px',
          background: 'rgba(239, 68, 68, 0.25)',
          border: '1px solid rgba(239, 68, 68, 0.5)',
          color: '#fca5a5',
          padding: '2px 8px',
          borderRadius: '10px',
          fontSize: '0.7em',
          fontWeight: '600',
          letterSpacing: '0.3px',
        }}>
          {station.badge}
        </div>
      )}

      {/* Icon Circle */}
      <div style={{
        width: '70px',
        height: '70px',
        borderRadius: '50%',
        background: station.gradient,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '2.0em',
        marginBottom: '15px',
        boxShadow: isHovered
          ? `0 8px 30px ${station.shadowColor}`
          : '0 4px 15px rgba(0,0,0,0.2)',
        transition: 'all 0.4s ease',
        transform: isHovered ? 'scale(1.1)' : 'scale(1)',
      }}>
        {station.icon}
      </div>

      {/* Title */}
      <h3 style={{
        color: '#ffffff',
        fontSize: '1.2em',
        fontWeight: '700',
        margin: '0 0 6px 0',
        letterSpacing: '0.5px',
      }}>
        {station.title}
      </h3>

      {/* Subtitle */}
      <span style={{
        display: 'inline-block',
        background: isHovered ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.08)',
        color: 'rgba(255,255,255,0.7)',
        padding: '4px 14px',
        borderRadius: '12px',
        fontSize: '0.75em',
        fontWeight: '500',
        letterSpacing: '0.5px',
        marginBottom: '12px',
        transition: 'background 0.3s ease',
      }}>
        {station.subtitle}
      </span>

      {/* Description */}
      <p style={{
        color: 'rgba(255,255,255,0.55)',
        fontSize: '0.85em',
        lineHeight: '1.6',
        margin: '0',
        fontWeight: '400',
      }}>
        {station.description}
      </p>

      {/* Hover Arrow Indicator */}
      <div style={{
        marginTop: '15px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        color: 'rgba(255,255,255,0.5)',
        fontSize: '0.82em',
        fontWeight: '500',
        opacity: isHovered ? 1 : 0,
        transform: isHovered ? 'translateY(0)' : 'translateY(8px)',
        transition: 'all 0.3s ease',
      }}>
        <span>เข้าใช้งาน</span>
        <span style={{ fontSize: '1.1em' }}>→</span>
      </div>
    </button>
  );
};

export default HomePage;
